import { AppModule } from 'app/module';
import 'module/socialMediaLinks/main';
import './styles.scss';
import Template from './template.hbs';

export class CompanyLocation extends AppModule {
    setTemplate() {
        this.template = Template;
        if (module.hot) {
            module.hot.accept('./template.hbs', () => {
                this.template = Template;
                this.render();
            });
        }
    }
}
